module.exports = __webpack_public_path__ + "static/media/banner_slider_line.4dd6469e.svg";